"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIlpContext = void 0;
var react_1 = require("react");
var IlpContext_1 = require("../contexts/IlpContext");
//This custom hook is responsible for consuming the ilp context.
function useIlpContext() {
    var context = (0, react_1.useContext)(IlpContext_1.IlpContext);
    if (!context) {
        throw new Error('The useIlpContext must be used within an IlpProvider.');
    }
    return context;
}
exports.useIlpContext = useIlpContext;
//# sourceMappingURL=useIlpContext.js.map